let isPriorityRenderingOverridden = false;

export function getPriorityRenderingOverrideState() {
    return isPriorityRenderingOverridden;
}

export function setPriorityRenderingOverrideState(isAllowed: boolean) {
    isPriorityRenderingOverridden = isAllowed;
}
